var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.79622C20 4.38591 15.5228 0 10 0C4.47715 0 0 4.38591 0 9.79622V10.2038C0 15.6141 4.47715 20 10 20C15.5228 20 20 15.6141 20 10.2038V9.79622Z",
    fill: "url(#paint0_linear_425_11102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0058 5.06736C12.7614 5.06736 14.9954 7.2576 14.9911 9.95821C14.9874 12.6141 12.767 14.8085 10.0558 14.8346C9.0397 14.8442 8.09399 14.5558 7.30199 14.0539C7.27791 14.0388 7.2489 14.0339 7.22174 14.0412L6.42912 14.2492L5.44082 14.5086L5.70564 13.5405L5.90997 12.7943C5.91737 12.7665 5.91244 12.7368 5.89577 12.7132C5.34452 11.9277 5.02044 10.9765 5.02044 9.95096C5.02044 7.25337 7.2526 5.06736 10.0058 5.06736ZM10.0058 4.04541C6.68159 4.04541 3.97658 6.69462 3.97658 9.95156C3.97658 10.9904 4.25065 11.9955 4.77413 12.8868C4.78709 12.9092 4.7908 12.9358 4.78401 12.9612L4.69758 13.2768L4.43276 14.245L3.96484 15.9551L5.71058 15.4967L6.69888 15.2373L7.06865 15.1405C7.09334 15.1339 7.11989 15.1369 7.14211 15.149C8.0193 15.614 8.99896 15.8577 10.0052 15.8577C13.3293 15.8577 16.0344 13.2085 16.0344 9.95156C16.0344 6.69462 13.33 4.04541 10.0052 4.04541H10.0058Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70748 7.25581C7.78465 7.22376 8.02046 7.19897 8.26676 7.23706C8.35751 7.25097 8.43343 7.31205 8.47294 7.39308C8.70011 7.86716 8.77604 8.05523 8.93901 8.41624C9.05815 8.67989 8.99024 8.9895 8.7748 9.18602C8.6748 9.27733 8.58158 9.3626 8.54022 9.40372C8.42232 9.52708 9.17235 10.9929 10.7236 11.4035C10.7965 11.4228 10.8749 11.3968 10.923 11.34C11.0798 11.1531 11.2304 10.9584 11.3866 10.7704C11.4638 10.6772 11.5946 10.6452 11.7088 10.6887C12.2231 10.8852 12.3706 10.9971 12.886 11.1942C13.0188 11.245 13.0854 11.3206 13.086 11.4603C13.0867 11.9078 12.9404 12.5016 12.2403 12.7302C12.1669 12.7544 11.9817 12.7786 11.9156 12.7828C9.90076 12.9062 7.24821 10.8278 6.97536 8.85827C6.97351 8.8486 6.97721 8.86795 6.97536 8.85827C6.8982 7.80367 7.51797 7.33563 7.70872 7.25641L7.70748 7.25581Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_11102",
    x1: 9.99969,
    y1: 0,
    x2: 9.99969,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#53F265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#35DD4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1DCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0DC12C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#03BA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00B822"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLive);
export default __webpack_public_path__ + "static/media/whatsapp-live.e603ee2443c7b9c3d5bb1fbb7787fd3d.svg";
export { ForwardRef as ReactComponent };